const button = {
    cancel: 'Abbrechen',
    ok: 'OK',
    discardChanges: 'Änderungen verwerfen',
    search: 'Durchsuchen',
    confirm: 'Bestätigen',
    choose: 'Auswählen',
    forward: 'Weiter',
    back: 'Zurück',
    reset: 'Zurücksetzen',
    apply: 'Anwenden',
    login: 'Anmelden',
    logout: 'Abmelden',
    send: 'Absenden',
    backToStart: 'Zurück zum Start',
    backToLogin: 'Zurück zum Login',
    no: 'Nein',
    yes: 'Ja',
    toPayment: 'Zur Zahlung',
    finishOrder: 'Bestellung Abschließen',
    thank: 'Vielen Dank',
    sendInvite: 'Einladung abschicken',
    resend: 'Erneut senden',
    startNow: 'Jetzt Starten',
    skip: 'Überspringen',
    register: 'Jetzt Registrieren',
    registerNoCode: 'Ohne Code Registrieren',
    save: 'Speichern',
    saveChanges: 'Änderungen übernehmen',
    delete: '{target} löschen',
    addCart: 'Liste zu Warenkorb hinzufügen',
    orderNow: 'Jetzt Bestellen',
    add: 'Hinzufügen',
    changePassword: 'Passwort ändern',
    changeLogin: 'Logindaten ändern',
    changeEmail: 'Email ändern',
    edit: 'Bearbeiten',
    share: 'Teilen',
    delivererNotFound: 'Lieferant nicht gefunden?',
    joinLocation: 'Team beitreten',
    createLocation: 'Location erstellen',
    editSupplier: 'Lieferant @.lower:button.edit',
    create: 'Erstellen',
    deleteSupplier: 'Lieferant löschen',
    forwardApp: 'Weiter zur App',
    endIntro: 'Einführung beenden',
    upload: 'Hochladen',
    showMore: "mehr anzeigen",
    hide: "verstecken",
    deleteAll: 'Alle löschen',
    settings: 'Einstellungen',
    manualSort: 'Manuelle Sortierung bearbeiten',
    switchOldVersion: 'Zur alten Version',
    goToAppVersion: 'Octopus im Browser verwenden',
    updateList: "Zur Liste hinzufügen",
    updateCart: "In den Warenkorb",
    openCameraScanner: 'Kamera-Scanner öffnen',
    orderOverview: 'Zur Bestellübersicht',
    deleteSupplierCart: 'Warenkorb löschen',
    resetAmount: 'Produktmengen zurücksetzen',
    requestAiCall: 'KI-Anruf anfordern',
    filter: {
        all: 'Alles',
        promotion: 'Aktionen',
        productSuggestion: 'Inspirationen'
    }
}

export default button
